import CloseOutlined from "@mui/icons-material/CloseOutlined";
import { Dialog, IconButton } from "@mui/material";
import "./LegalNotesDialog.css";
import "../Components/Components.css";

const LegalNotesDialog = ({ isOpen, setIsLegalNotesDialogShown }) => {
  const handleClose = () => {
    setIsLegalNotesDialogShown(false);
  };

  return (
    <Dialog
      open={isOpen}
      className="dialog legal-notes-dialog"
      fullWidth
      maxWidth="lg"
      scroll="paper"
      onClose={handleClose}
    >
      <div className="dialog-container">
        <div className="dialog-content">
          <IconButton className="close-button" onClick={handleClose}>
            <CloseOutlined />
          </IconButton>

          <h2 className="title">Legal Notes</h2>
          <div className="placeholder" />
        </div>

        <section className="buttons">
          <button className="cancel" type="button" onClick={handleClose}>
            Back
          </button>
        </section>
      </div>
    </Dialog>
  );
};

export default LegalNotesDialog;
